/* eslint-disable */
import i from './r1.js'

var r = function () {
  function n() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 256;
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, n),
      this.MAX_VERTICES = e,
      this.MAX_VERTICES_MASK = this.MAX_VERTICES - 1,
      this.amplitude = 1,
      this.scale = 1,
      this.min = 0,
      this.max = 0,
      this.scaledValue = 0,
      this.floorValue = 0,
      this.t = 0,
      this.tRemapSmoothstep = 0,
      this.r = [];
    for (var t = 0; t < this.MAX_VERTICES; ++t)
      this.r[t] = Math.random()
  }
  return i(n, [{
    key: "getVal",
    value: function (e) {
      return this.scaledValue = e * this.scale,
        this.floorValue = Math.floor(this.scaledValue),
        this.t = this.scaledValue - this.floorValue,
        this.tRemapSmoothstep = this.t * this.t * (3 - 2 * this.t),
        this.min = this.floorValue & this.MAX_VERTICES_MASK,
        this.max = this.min + 1 & this.MAX_VERTICES_MASK,
        this.lerp(this.r[this.min], this.r[this.max], this.tRemapSmoothstep) * this.amplitude
    }
  }, {
    key: "lerp",
    value: function (e, t, n) {
      return e * (1 - n) + t * n
    }
  }, {
    key: "dispose",
    value: function () {
      this.r = null
    }
  }]),
    n
}();
var t = { default: r }

export default t
